import { ServerLocation } from '@xing-com/crate-core-router';
import type { ServerRuntime } from '@xing-com/crate-xinglet/internal';

export type ServerRootProps = React.PropsWithChildren<{
  runtime: ServerRuntime;
}>;

export const ServerRoot: React.FC<ServerRootProps> = ({
  children,
  runtime,
}) => {
  const { pathname, search } = runtime.request.url;

  return (
    <ServerLocation url={`${pathname}${search}`}>{children}</ServerLocation>
  );
};
